import { render, staticRenderFns } from "./GameGeneral.vue?vue&type=template&id=5b043a72&scoped=true"
import script from "./GameGeneral.vue?vue&type=script&lang=js"
export * from "./GameGeneral.vue?vue&type=script&lang=js"
import style0 from "./GameGeneral.vue?vue&type=style&index=0&id=5b043a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b043a72",
  null
  
)

export default component.exports